import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./cookies.css";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isModalOpen, setsModalOpen] = useState(false);
  const [fadeClass, setFadeClass] = useState("");

  const showModal = () => {
    if (!isModalOpen) {
      setFadeClass("fade-in");
      setsModalOpen(true);
    }
  };

  const hideModal = () => {
    setFadeClass("fade-out");
    setTimeout(() => {
      setsModalOpen(false);
      setFadeClass("");
    }, 300);
  };

  const savePreferences = () => {
    handleAccept();
    hideModal();
  };

  const rejectNonEssential = () => {
    hideModal();
    handleReject();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isModalOpen && !event.target.closest(".modal-content")) {
        hideModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isModalOpen]);

  useEffect(() => {
    const consent = getCookie("cookieConsent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  };

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  const handleAccept = () => {
    setCookie("cookieConsent", "accepted", 30);
    setIsVisible(false);
  };

  const handleReject = () => {
    setCookie("cookieConsent", "rejected", 30);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookieContainer">
      <div className="cookieInner">
        <div className="text">
          <i>
            We use cookies to enhance your browsing experience. Some cookies
            are Essential and necessary to run the website, others are
            optional, including Personalization and Performance Cookies. By
            clicking accept, you agree to receive all cookies and similar
            technologies.
            <span
              style={{
                color: "#649eff",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => showModal()}
            >
              You can change the optional cookie settings here if you wish.
            </span>{" "}
            For more information,{" "}
            <Link
              to="https://app.regulatecpg.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              <span
                style={{
                  color: "#649eff",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                please see our Privacy Statement.
              </span>
            </Link>
          </i>
        </div>
        <div className="cookieButtonContainer">
          <button className="cookieButton" onClick={handleReject}>
            <svg
              className="reject-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
            Reject all cookies
          </button>
          <button className="cookieButton" onClick={handleAccept}>
            <svg
              className="check-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <path d="M5 13l4 4L19 7" />
            </svg>
            Accept all cookies
          </button>
        </div>

        {isModalOpen && (
          <div className={`modalContainerForCookie model ${fadeClass}`}>
            <div className="modal-content modelContentPadding bg-white p-6 rounded-lg shadow-lg max-w-md w-11/12">
              <h2 className="text-2xl font-bold mb-4">
                Manage Your Cookie Preferences
              </h2>
              <hr className="my-4" />
              <h3 className="text-lg font-semibold">
                Cookies that are strictly necessary
              </h3>
              <p className="mb-4">
                These cookies are necessary for the website to function and
                cannot be switched off in our systems. They are usually only
                set in response to actions made by you which amount to a
                request for services, such as setting your privacy
                preferences, logging in or filling in forms. You can set your
                browser to block or alert you about these cookies, but some
                parts of the site will not then work. These cookies do not
                store any personally identifiable information
              </p>
              <p className="text-blue-600">Always On</p>
              <hr className="my-4" />
              <h3 className="text-lg font-semibold">
                Cookies that help with our communications and marketing
              </h3>
              <p className="mb-4">
                These cookies enable us to show marketing messages and
                first-party ads, and to measure the effectiveness of our
                social media presence. They may be used by us to group you in
                a targeting segment with people who have similar interests.
              </p>
              <div className="d-flex gap-4 align-items-center mb-4">
                <label className="mr-4">
                  <input
                    type="radio"
                    defaultChecked
                    name="marketingCookies"
                    value="on"
                  />{" "}
                  On
                </label>
                <label>
                  <input type="radio" name="marketingCookies" value="off" />{" "}
                  Off
                </label>
              </div>
              <div className="d-flex gap-4 align-items-center ">
                <button
                  onClick={savePreferences}
                  className="btn btn-outline-primary buttonText"
                >
                  Save Preferences
                </button>
                <button
                  onClick={rejectNonEssential}
                  className="btn btn-outline-primary buttonText"
                >
                  Reject Non-essential Cookies
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CookieConsent;
